export function throwXtractError(code) {
  return {
    type: 'THROW_XTRACT_ERROR',
    code
  }
}
